// extracted by mini-css-extract-plugin
export default {"nav_distance":"navbar_nav_distance__oCi1p","border_bottom_navbar":"navbar_border_bottom_navbar__Xlnu7","border_bottom_active":"navbar_border_bottom_active__pN5WF"};